<template>
  <div class="privacy" v-if="showPrivacy">
    <div class="privacy-content">
      <iframe
        :style="iframeStyle"
        id="iframe"
        frameborder="0"
        src="https://www.12kcool.com/privacy-visitor.html"
        scrolling="no"
        height="100%"
        width="100%"
      />
    </div>
    <div class="privacy-footer">
      <div class="agree">
        <van-checkbox
          v-model="agree"
          icon-size="18px"
          checked-color="#1cab7d"
          shape="square"
          >我已阅读并同意</van-checkbox
        >
        <span class="mainColor face-privaty">《{{ agreeTxt }}》</span>
      </div>
      <div class="button">
        <van-button size="large" color="#1cab7d" round @click="toDetail">
          确定
        </van-button>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { Toast, Button, Checkbox } from "vant";
import Account from "@/api/account";

export default defineComponent({
  name: "Privacy",
  data() {
    return {
      agreeTxt: "访客安全责任书",
      resizeFlag: false,
      iframeStyle: {
        height: "100%",
        width: "100%",
      },
      visit_protocol: false,
      visitor_roles: [],
      showPrivacy: false,
      agree: false,
      school_id: "",
    };
  },
  components: {
    "van-button": Button,
    "van-checkbox": Checkbox,
  },
  methods: {
    getSchoolConfig(school_id: string) {
      Account.getConfig(school_id)
        .then((res) => {
          console.log("getConfig", res);
          const data = res.data || {};
          this.visitor_roles = data.visitor_roles || [];
          this.visit_protocol = data.visit_protocol || false;
          if (this.visitor_roles.length && this.visit_protocol) {
            this.showPrivacy = true;
          } else {
            this.toHome();
          }
        })
        .catch((err) => {
          console.log("getConfig", err);
          this.toHome();
        });
    },
    toDetail() {
      if (!this.agree) {
        Toast(`请阅读并同意《${this.agreeTxt}》`);
        return;
      }
      this.toHome();
    },

    toHome() {
      this.$router.replace({
        path: "/home",
        query: this.$route.query || {},
      });
    },
  },
  mounted() {
    window.addEventListener(
      "message",
      (event) => {
        if (event.data.name === "protocol" && event.data.height) {
          if (!this.resizeFlag) {
            this.resizeFlag = true;
            this.iframeStyle.height = event.data.height + 20 + "px";
            // console.log('当前iframe 高度：', this.iframeStyle.height)
            setTimeout(() => {
              this.resizeFlag = false;
            }, 500);
          }
        }
      },
      false
    );
  },
  created() {
    const query = this.$route.query || {};
    const school_id: any = query.school_id || "";
    this.school_id = school_id;
    this.getSchoolConfig(this.school_id);
  },
});
</script>
<style scoped lang="scss">
.privacy {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  &-content {
    flex: 1;
    min-height: 0;
    overflow: auto;
    iframe {
    }
  }
  &-footer {
    flex-basis: 100px;
    min-height: 100px;
    .agree {
      padding: 12px;
      display: inline-flex;
      align-items: center;
      font-size: 14px;
      // :deep(.van-checkbox__label) {
      //   line-height: normal;
      // }
    }
    .button {
      width: 80%;
      margin: auto;
    }
  }
}
</style>
